<template>
  <Message v-if="validationError" :closeable="false" severity="error">{{ validationError }}</Message>
  <Card class="mt-4 px-2" pt:body:class="py-0 px-2">
    <template #content>
      <form @submit="onSubmit">
        <StackedLabelInput name="name" label="Name" classes="required" />
        <StackedLabelInput name="abbrev" label="Abbreviation (Optional)" classes="mt-2" />
        <div class="flex mt-4 justify-end">
          <SubmitButton />
        </div>
      </form>
    </template>
  </Card>
</template>

<script setup lang="ts">
import { useForm } from "vee-validate";
import { toTypedSchema } from "@vee-validate/zod";
import { toFormData } from "@/services/Utility";
import { type Code, type CodeTable } from "@/types/Codes";
import { z } from "zod";

onMounted(async (): Promise<void> => {});

const emit = defineEmits<{
  submitted: [];
}>();

interface Props {
  table?: CodeTable;
  code?: Code;
  mode: "Add" | "Edit";
}
const props = defineProps<Props>();

const validationError = ref("");

const AddCodeSchema = z.object({
  name: z.string().min(1, { message: "A name is required" }),
  abbrev: z.string().optional(),
});

let initialValues: any = {};

if (props.code) {
  if (props.mode === "Edit") {
    initialValues.name = props.code.name;
    initialValues.abbrev = props.code.abbrev;
  } else {
    initialValues.name = "";
    initialValues.abbrev = "";
  }
}

const { handleSubmit } = useForm({
  validationSchema: toTypedSchema(AddCodeSchema),
  initialValues: initialValues,
  keepValuesOnUnmount: true,
});

const onSubmit = handleSubmit((values: any): void => {
  let data = AddCodeSchema.parse(values);
  let url = props.mode === "Edit" ? "/codes/edit/" + props.table!.tableNum + "/" + props.code!.num : "/codes/add/" + props.table!.tableNum;

  axios.post(url, toFormData(data)).then((response) => {
    handleApiResponse(
      response,
      () => {
        success(props.table!.name + " added!", "");
        emit("submitted");
      },
      (errors: ApiError[]) => {
        validationError.value = errors[0].message;
      }
    );
  });
});
</script>
